import React, { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { SectionTitle, Btn } from "@/components/Brutal";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { KeyRound, ShieldCheck } from "lucide-react";

export default function MyPin() {
  const { user } = useAuth();
  const [me, setMe] = useState(null);
  const [oldPin, setOldPin] = useState("");
  const [pin, setPin] = useState("");
  const [pin2, setPin2] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get("/auth/me");
    setMe(data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length < 4 || pin.length > 6) { toast.error("PIN deve ter 4 a 6 dígitos"); return; }
    if (pin !== pin2) { toast.error("Confirmação não confere"); return; }
    setBusy(true);
    try {
      const payload = { pin };
      if (me?.has_pin) payload.old_pin = oldPin;
      await api.post("/auth/set-pin", payload);
      toast.success("PIN salvo com sucesso");
      setOldPin(""); setPin(""); setPin2("");
      load();
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="my-pin-page">
      <SectionTitle>Meu PIN · <KeyRound className="inline w-5 h-5 -mt-1" /></SectionTitle>

      <div className="max-w-xl">
        <div className="brutal-card p-5">
          <div className="flex items-start gap-3 mb-4 pb-3 border-b-2 border-[#111]">
            <ShieldCheck className="w-8 h-8 text-[#1A7F37]" />
            <div>
              <div className="font-display font-bold uppercase text-lg">{user?.name}</div>
              <div className="text-xs text-[#555]">{user?.email}</div>
              <div className="mt-1">
                {me?.has_pin
                  ? <span className="inline-block px-2 py-0.5 bg-[#1A7F37] text-white text-[10px] font-display font-bold uppercase tracking-wider">PIN definido</span>
                  : <span className="inline-block px-2 py-0.5 bg-[#FFC107] text-[#111] text-[10px] font-display font-bold uppercase tracking-wider">Sem PIN</span>}
              </div>
            </div>
          </div>

          <div className="brutal-card-sm p-3 bg-[#FFF8E1] text-xs text-[#7C2D12] mb-4">
            🔒 Seu PIN é exigido apenas para <b>aprovar ou rejeitar requisições de combustível</b>. Ele protege a ação caso alguém pegue seu celular já logado.
          </div>

          <form onSubmit={submit} className="space-y-3">
            {me?.has_pin && (
              <div>
                <label className="block font-mono-data text-[10px] uppercase tracking-widest text-[#555] mb-1">PIN atual</label>
                <input type="password" inputMode="numeric" maxLength={6} value={oldPin} onChange={(e) => setOldPin(e.target.value.replace(/\D/g, ""))} className="w-full border-2 border-[#111] p-2 text-lg text-center font-mono-data tracking-[0.5em]" data-testid="old-pin" />
              </div>
            )}
            <div>
              <label className="block font-mono-data text-[10px] uppercase tracking-widest text-[#555] mb-1">Novo PIN (4 a 6 dígitos)</label>
              <input type="password" inputMode="numeric" maxLength={6} value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} className="w-full border-2 border-[#111] p-2 text-lg text-center font-mono-data tracking-[0.5em]" data-testid="new-pin" />
            </div>
            <div>
              <label className="block font-mono-data text-[10px] uppercase tracking-widest text-[#555] mb-1">Confirme o novo PIN</label>
              <input type="password" inputMode="numeric" maxLength={6} value={pin2} onChange={(e) => setPin2(e.target.value.replace(/\D/g, ""))} className="w-full border-2 border-[#111] p-2 text-lg text-center font-mono-data tracking-[0.5em]" data-testid="new-pin-2" />
            </div>
            <Btn type="submit" disabled={busy} data-testid="save-pin">{busy ? "Salvando…" : (me?.has_pin ? "Trocar PIN" : "Definir PIN")}</Btn>
          </form>
        </div>
      </div>
    </div>
  );
}
